import { Global, css } from '@emotion/react'

import colors from 'design-system/tokens/colors'
import fonts from 'design-system/tokens/fonts'
import fontSizes from 'design-system/tokens/fontSizes'

import formsStyles from './formsStyles'
import normalizeStyles from './normalizeStyles'
import typographyStyles from './typographyStyles'

const styles = css`
  ${normalizeStyles}

  * {
    box-sizing: inherit;

    &:after,
    &:before {
      box-sizing: inherit;
    }
  }

  html {
    font-size: 10px;

    scroll-behavior: smooth;
    @media (prefers-reduced-motion) {
      scroll-behavior: initial;
    }
  }

  html,
  body,
  #root {
    height: 100%;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    color: ${colors.black};
    font-family: ${fonts.body}, sans-serif;
    font-size: ${fontSizes.body};
    line-height: 20px;
    margin: 0;
    min-height: 100%;
    overflow-x: auto;
    overflow-y: auto;
  }

  #root {
    min-height: 100%;
  }

  a {
    color: ${colors.blues.link};
    text-decoration: none;
  }

  a:hover,
  a:active,
  a:focus {
    color: ${colors.blues.hover};
    outline: none;
    text-decoration: none;
  }

  var {
    font-style: inherit;
  }

  a,
  button {
    /*
     * Override Bootstrap's default focus style
     * https://github.com/joinswoop/swoop/pull/42611#discussion_r1943294023
     */
    &:focus:is(:focus-visible) {
      outline: auto ${colors.primary};
      outline-offset: 2px;
    }
  }

  input[type='checkbox']:focus:is(:focus-visible) {
    outline: auto ${colors.primary};
    outline-offset: 2px;
  }

  input,
  select,
  textarea {
    &:focus:is(:focus-visible) {
      outline: auto ${colors.primary};
    }
    &[aria-required='true']:focus:is(:focus-visible) {
      outline-offset: 4px;
    }
  }

  ul {
    list-style: none;
  }

  input {
    text-overflow: ellipsis;
  }

  caption {
    text-align: left;
  }
  th {
    text-align: left;
  }

  hr {
    border: 1px solid ${colors.grays.l6};
    margin: 0 10px 10px 0;
    padding-right: 0;
    width: 100%;
    min-width: 200px;
  }

  ${formsStyles}
  ${typographyStyles}
`

const GlobalStyles = () => <Global styles={styles} />

export default GlobalStyles
